export default __webpack_public_path__ + "static/n-unit-5c5e8b9c657a933d77f2048a80fef2b5.svg";